export function transformToElapsedTime(seconds: number, miliseconds: number) {
  const minutes = Math.trunc(miliseconds / 60);
  const minutesText = minutes > 9 ? minutes : `0${minutes}`;
  const secondsText = seconds > 9 ? seconds : `0${seconds}`;
  return `${minutesText}:${secondsText}`;
}
